import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { post_ForgotPassword } from '../services/ForgotPassword';
import EmailValidatedComponent from './EmailValidatedComponent';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState<any>({
        emailAddress: "",
    });
    const [message, setMessage] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsProcessing(true);
        setMessage('');
        setErrorMessage('');

        post_ForgotPassword(userData.emailAddress)
            .then((res) => {
                if (res === userData.emailAddress) {
                    setMessage(`We've emailed a link to ${userData.emailAddress} to let you update your password. 
                        If you don't see the email, be sure to check your spam and junk mail folders.`);
                    setIsSuccess(true);
                } else {
                    setErrorMessage('Your email address does not exist.');
                }
                setIsProcessing(false);
                setUserData({ emailAddress: '' });
            })
            .catch((error) => {
                if (error.response && error.response.status === 500) {
                    setErrorMessage('There is some problem occurring. Please try again later.');
                } else {
                    setErrorMessage('Your email address does not exist.');
                }
                console.error(error);
                setIsProcessing(false);
            });
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#f8fafc] via-[#eef2f6] to-[#dce3eb] flex items-center justify-center p-4">

            <div className="w-full max-w-md bg-white/60 backdrop-blur-xl shadow-2xl border border-white/40 rounded-3xl p-8 animate-fadeIn">

                <h2 className="text-3xl font-extrabold text-center bg-gradient-to-r from-[#121212] to-[#5b5b5b] bg-clip-text text-transparent mb-6">
                    Forgot Password
                </h2>

                {!isSuccess ? (
                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div>
                            <label className="block text-gray-800 font-semibold mb-1">
                                Enter Email
                            </label>

                            <EmailValidatedComponent
                                text={userData.emailAddress}
                                setText={(value) => setUserData({ ...userData, emailAddress: value })}
                                className="block w-full rounded-xl border border-gray-300 px-4 py-3 shadow-sm outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all placeholder:text-gray-400"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={isProcessing}
                            className={`w-full py-3 rounded-full text-white font-semibold tracking-wide shadow-lg transition-all ${isProcessing
                                ? "bg-[#222] cursor-not-allowed"
                                : "bg-[#121212] hover:bg-black"
                                }`}
                        >
                            {isProcessing ? (
                                <div className="flex justify-center items-center gap-2">
                                    <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                                    Processing...
                                </div>
                            ) : (
                                "Reset Password"
                            )}
                        </button>
                    </form>
                ) : (
                    <div className="text-center space-y-6">
                        <div className="text-green-700 font-medium text-lg my-4">{message}</div>

                        <button
                            onClick={() => navigate("/login")}
                            className="w-full py-3 bg-[#121212] text-white rounded-full text-sm font-semibold tracking-wide hover:bg-black transition-all shadow-lg"
                        >
                            Go back to Sign In
                        </button>
                    </div>
                )}

                {errorMessage && (
                    <div className="mt-6 text-center text-red-500 font-medium">
                        {errorMessage}
                    </div>
                )}
            </div>
        </div>

    );
};

export default ForgotPassword;